jQuery(document).ready(function($){
    // now you can use jQuery code here with $ shortcut formatting
    // this will execute after the document is fully loaded
    // anything that interacts with your html should go here

    $('#notattend-0').on('change', function() {
        $('#attendace-0').not(this).prop('checked', false);
    });

    $('#attendace-0').on('change', function() {
        $('#notattend-0').not(this).prop('checked', false);
    });
});